import { useTranslation } from "react-i18next";
import CustomizedBreadcrumbs from "../../../components/Custom/CustomizedBreadcrumbs";
import { Box, Typography } from "@mui/material";
import CustomizedButton from "../../../components/Custom/CustomizedButton";
import { IBreadcrumbsAndMenu } from "../../../types/global";
import { useNavigate } from "react-router-dom";
import BranchSettingTable from "../../../components/Table/Setting/Branch";
import { useStateContext } from "../../../contexts/auth-context";

const BranchSetting = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    state: { permissions },
  } = useStateContext();

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("setting.index"),
      to: "/setting",
    },
    {
      name: t("setting.business.index"),
      to: "/setting/business",
    },
    {
      name: t("branch.index"),
      to: "/setting/business/branch",
    },
  ];

  return (
    <>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <Box sx={{ display: "flex", justifyContent: "space-between", my: 3 }}>
        <Typography variant="h5">{t("branch.info")}</Typography>
        {permissions?.branch?.create && (
          <CustomizedButton
            title={t("button.add") + t("branch.index")}
            variant="contained"
            onClick={() => {
              navigate("/setting/business/branch/add");
            }}
          />
        )}
      </Box>
      <BranchSettingTable />
    </>
  );
};

export default BranchSetting;
